import { ActionIcon, Modal, ScrollArea, Tooltip, useMatches, Button, TextInput } from "@mantine/core";
import { IconArrowBigDownLineFilled } from "@tabler/icons-react";
import { Document, Page } from "react-pdf";
import { useState } from "react";
import toast from "react-hot-toast";
import { db } from '../firebase';
import { doc, getDoc,setDoc } from "firebase/firestore";
import emailjs from '@emailjs/browser';

const ResumeViewer = (props: any) => {
    const [isViewing, setIsViewing] = useState(false);
    const [inputKey, setInputKey] = useState("");
    const [emailInput, setEmailInput] = useState(""); 
    const [isAccessGranted, setIsAccessGranted] = useState(true);// change this
    const [isDownloadEnabled, setIsDownloadEnabled] = useState(true);
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [numPages, setNumPages] = useState<number | null>(null);


    const btn = useMatches({
        xs: 'xs',
        sm: 'sm',
        md: 'md',
    });

    const generateAccessKey = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let accessKey = '';
        for (let i = 0; i < 7; i++) {
            accessKey += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return accessKey;
    };
    const toastStyles = {
        backgroundColor: "#0A0A0A",
        color: "#8892B0",
        border: "1px solid #64FFDA",
        padding: "10px",
        borderRadius: "5px",
    };

    const handleAccessSubmit = async () => {
        const currentTime = new Date().toLocaleString();
        try {
       const accessKeyDoc = await getDoc(doc(db, "settings", "resumeAccessKey"));
            const accessKeysFromSettings = accessKeyDoc.exists() ? [accessKeyDoc.data().key] : [];
    
            
            const constantKeysDoc = await getDoc(doc(db, "constantKeys", "allAccessKeys"));
            const constantKeys = constantKeysDoc.exists() ? constantKeysDoc.data().keys || [] : [];
    
           
            const allAccessKeys = [...accessKeysFromSettings, ...constantKeys];
    
            
            const expiresAt = accessKeyDoc.exists() && accessKeyDoc.data().expiresAt ? accessKeyDoc.data().expiresAt : null;
            let isValid = false; 
    
          
            if (allAccessKeys.includes(inputKey)) {
                isValid = true; 
                if (accessKeysFromSettings.includes(inputKey) && expiresAt) {
                    const expirationDate = new Date(expiresAt);
                    const currentTime = new Date();
                    
                    if (currentTime > expirationDate) {
                        toast.error("Access key has expired. Request a new one.", { style: toastStyles });
                        return;
                    }
                }
    
                setIsAccessGranted(true);
                setIsDownloadEnabled(true);
                toast.success("Access granted!", { style: toastStyles });
            } else {
                toast.error("Invalid access key.", { style: toastStyles });
            }
    
            const templateParams = {
                access_key: inputKey,
                email: emailInput,
                timestamp: currentTime,
                is_valid: isValid ? "Valid" : "Invalid", 
            };
    
       
            emailjs.send('service_nlds6fh', 'template_wtk2ysg', templateParams, 'CPgZoAFYXY-JYOWyg')
                .then((response) => {
                    // console.log('Email sent for access key!', response.status, response.text);
                    // toast.success(`Access key details (${isValid ? 'Valid' : 'Invalid'}) sent via email!`, { style: toastStyles });
                }, (err) => {
                    console.error('Failed to send email. Error: ', err);
                    // toast.error("Failed to send access key details via email.", { style: toastStyles });
                });
    
        } catch (error) {
            console.error("Error fetching access key:", error);
            toast.error("Failed to verify access key.", { style: toastStyles });
        }
    };
    
    

  

    const handleSendAccessKeyEmail = async () => {
        if (!emailInput) {
            toast.error("Please enter a valid email.", { style: toastStyles });
            return;
        }

        const accessKey = generateAccessKey(); 
        const currentTime = new Date();
        const expirationTime = new Date(currentTime.getTime() + 20 * 60000); // Expires in 20 minutes

        try {
        
            await setDoc(doc(db, "settings", "resumeAccessKey"), {
                key: accessKey,
                expiresAt: expirationTime.toISOString(),
            });

            const templateParams = {
                email: emailInput,
                access_key: accessKey,
            };

  
            emailjs.send('service_nlds6fh', 'template_iyudm0r', templateParams, 'CPgZoAFYXY-JYOWyg')
                .then((response) => {
                    toast.success("Access key sent via email!", { style: toastStyles });
                    setEmailModalOpen(false);
                }, (err) => {
                    console.error('Failed to send email. Error: ', err);
                    toast.error("Failed to send access key via email.", { style: toastStyles });
                });
        } catch (error) {
            console.error("Error saving access key:", error);
            toast.error("Failed to generate access key.", { style: toastStyles });
        }
    };

    const handleDownloadClick = (event: React.MouseEvent) => {
        if (!isDownloadEnabled) {
            event.preventDefault();
        }
    };

    const handleRequestAccessKey = () => {
        setEmailModalOpen(true); 
    };



    return (
        <>
            <Modal.Root
                scrollAreaComponent={ScrollArea.Autosize}
                size="auto"
                centered
                className="font-mono"
                opened={props.opened}
                onClose={props.close}
            >
                <Modal.Overlay className="!backdrop-opacity-85 blur-sm" />

                <Modal.Content className="!rounded-3xl">
                    <Modal.Header className="!bg-bgColor xs-mx:!p-2 !border-primaryColor xs-mx:!border !border-2 xs-mx:!border-b-0 !border-b-0 !rounded-tl-3xl !rounded-tr-3xl">
                        <Modal.Title
                            data-autofocus
                            className="!text-4xl xs-mx:!text-2xl text-white flex gap-3 items-center !font-bold"
                        >
                            Resume
                            <Tooltip
                                label="Download"
                                className="!text-bgColor"
                                color="#64FFDA"
                                position="right"
                                offset={5}
                                disabled={!isDownloadEnabled}
                            >
                                <ActionIcon
                                    className={` ${!isDownloadEnabled ? 'opacity-40 cursor-not-allowed' : ''}`}
                                    component="a"
                                    {...(isDownloadEnabled ? {} : { href: '#' })}
                                    href="JeevanKumarKorraCV.pdf"
                                    size={btn}
                                    // download={Info.name}
                                    variant="outline"
                                    color="#64FFDA"
                                    disabled={!isDownloadEnabled}
                                    onClick={handleDownloadClick}
                                >
                                    <IconArrowBigDownLineFilled />
                                </ActionIcon>
                            </Tooltip>
                        </Modal.Title>
                        <Modal.CloseButton size="md" iconSize="30px" className="!bg-bgColor !text-red-500" />
                    </Modal.Header>

                    <Modal.Body className="relative !bg-bgColor xs-mx:!p-2 !pt-2 !border-primaryColor !border-2 xs-mx:!border xs-mx:!border-t-0 !border-t-0 !rounded-bl-3xl !rounded-br-3xl">
                        <Document
  file="JeevanKumarKorraCV.pdf"
  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
  className={`w-full rounded-2xl ${isAccessGranted ? '' : 'blur-sm'}`}
>
                            {Array.from(new Array(numPages), (_, index) => (
  <Page
    key={`page_${index + 1}`}
    pageNumber={index + 1}
    renderTextLayer={false}
    renderAnnotationLayer={false}
    className="mb-6"
  />
))}

                        </Document>

                        {/* {!isViewing && (
                            <div className="absolute inset-0 flex justify-center items-center bg-opacity-50 bg-black">
                                <Button className="!bg-bgColor !text-primaryColor border-bgColor shadow-primaryColor shadow-sm" onClick={() => setIsViewing(true)}>
                                    View Resume
                                </Button>
                            </div>
                        )} */}

                        {isViewing && !isAccessGranted && (
                            <div className="absolute inset-0 flex justify-center items-center bg-opacity-50 bg-black">
                                <div className="bg-bgColor p-6 rounded-lg shadow-primaryColor shadow-sm">
                                    <TextInput
                                        label="Access Key"
                                        value={inputKey}
                                        onChange={(event) => setInputKey(event.currentTarget.value)}
                                        placeholder="Enter access key to view resume"
                                        classNames={{
                                            input: "text-white !bg-bgColor border-primaryColor",
                                            label: "!text-primaryColor",
                                        }}
                                        styles={{
                                            input: {
                                                color: '#ffffff',
                                                backgroundColor: '#0A0A0A',
                                                borderColor: '#64FFDA',
                                            },
                                            label: {
                                                color: '#64FFDA',
                                            }
                                        }}
                                    />
                                    <div className="flex justify-between mt-3">
                                        <Button className="!bg-primaryColor shadow-md !text-bgColor" onClick={handleAccessSubmit} color="black" variant="filled">
                                            Submit
                                        </Button>
                                        <Button className="!bg-primaryColor shadow-md !text-bgColor ml-1" onClick={handleRequestAccessKey} color="black" variant="filled">
                                            Request Access Key
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                </Modal.Content>
            </Modal.Root>
           
            <Modal 
  opened={emailModalOpen}
  onClose={() => setEmailModalOpen(false)}
  title="REQUEST ACCESS KEY"
  styles={{
    content: { 
      backgroundColor: '#0A0A0A',  
      padding: '1.5rem',
      borderRadius: '0.5rem',     
      boxShadow: '4px 4px 8px rgba(100, 255,218, 0.1)', 
    },
    header: {
      backgroundColor: '#0A0A0A', 
    },
    title: {
      color: '#64FFDA',  
    },
  }}
>
  <TextInput
    label="Email ID"
    value={emailInput}
    onChange={(event) => setEmailInput(event.currentTarget.value)}
    placeholder="Enter your email"
    classNames={{
      input: "!text-gray-300 !bg-bgColor border-primaryColor",
      label: "!text-primaryColor",
    }}
    styles={{
      input: {
        color: '#64FFDA',
        backgroundColor: '#0A0A0A', 
        borderColor: '#64FFDA',     
      },
      label: {
        color: '#64FFDA',         
      }
    }}
  />

  <Button 
    className="!bg-primaryColor shadow-md !text-bgColor mt-3" 
    onClick={handleSendAccessKeyEmail}
  >
    Send Access Key
  </Button>
</Modal>

           
        </>
    );
};

export default ResumeViewer;
